import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import _ from "lodash";
import { Subscription, debounceTime } from "rxjs";
import { DataService } from "src/app/services/data.service";
import { FilterService } from "src/app/services/filter.service";
import { NavigationService } from "src/app/services/navigation.service";
import { NewFilterService } from "src/app/services/new-filter.service";
import { RouterHandlerService } from "src/app/services/router-handler.service";

@Component({
    selector: "app-prescriber-offices-list",
    templateUrl: "./prescriber-offices-list.component.html",
    styleUrls: ["./prescriber-offices-list.component.scss"],
    standalone: false
})

export class PrescriberOfficesListComponent implements OnInit, OnDestroy {
  @Input("heading") heading = "Account list";
  @Input("item") item: any;
  @Input("allData") allData: any = [];
  @Input("statusArray") statusArray: any = [];

  clientKey: any;
  moduleKey: any;
  dashboardKey: any;
  routeParams: any;

  // Icons
  status_tick = "status_tick";
  status_na = "status_na";
  status_pending = "status";
  status_circle = "status_circle";
  status_ns = "status_ns";

  sortByArray:any = [
    {
      name: 'Accounts',
      value: 'account_name'
    },
    {
      name: 'Prescribers',
      value: 'prescriber_count'
    },
    {
      name: 'Total Patients',
      value: 'pending_patient'
    },
    {
      name: 'Lagging Patients',
      value: 'lagging_patient'
    }
  ]

  sortByvalue:any = "account_name";
  sortingIcon = false;

  groupData: any = [];
  backUpGroupedData: any = [];
  isDataLoaded = false;
  toggleSelection = 'state';
  showToggle: boolean = false;
  panelOpenState = false;
  reqSubcription: Subscription[] = [];

  groupConfigKey: any = [];
  groupLocConfigKey: any = [];
  configToShowStateValues = [];
  configToShowLocationValues = [];
  configToShowStatusJourney = {};
  groupConfigObj = {};

  moduleName: any;
  cardName: any;
  decryptedParams: any;
  
  currentStateCode:any;
  statusArrayforPrescriber:any = [];
  patientStatusJourneyFlg = true;

  constructor(
    public dataSource: DataService,
    private route: ActivatedRoute,
    private newFilterService: NewFilterService,
    private dataService: DataService,
    private filterServiceOld: FilterService,
    private routerHandlerService: RouterHandlerService,
    private navigationService: NavigationService,
    private cdr: ChangeDetectorRef,
    private filterService: FilterService
  ) {

    // Click from Coropleth Map
    this.reqSubcription.push(
      this.dataService.getState.pipe(debounceTime(300)).subscribe((resp: any) => {
        // debugger
        if (resp) {
          this.currentStateCode = resp;
          this.loadLocationLevelApi(resp);
          // let fnd = this.allData.find((o: any) => o.state_cd == resp)
          // if (fnd) {
          //   this.groupData = this.backUpGroupedData.filter((f: any) => f.name == fnd[this.groupConfigKey.toString()]);
          // }
          // this.showToggle = true;
        }

      })
    );

    // Click from Coropleth Map Back Button
    this.reqSubcription.push(
      this.dataService.backToDefault.pipe(debounceTime(200)).subscribe((resp: any) => {
        // debugger;
        if (resp) {
          this.groupData = [...this.backUpGroupedData];
          this.showToggle = false;
          this.toggleSelection = 'state';
          this.currentStateCode = '';
        }
      })
    );

    // Click from Coropleth Map Location Level
    this.reqSubcription.push(
      this.dataService.showLocationLevelData.pipe(debounceTime(300)).subscribe((resp: any) => {
        // debugger;
        if (resp) {
          this.currentStateCode = resp.state;
          let fnd: any = this.allData.find((o: any) => o.state_cd == resp.state);
          if (fnd) {
            // let groupData:any = this.allData.filter((f: any) => f[this.groupConfigKey.toString()] == fnd[this.groupConfigKey.toString()] && f.zip_code == resp.postcode);
            const stateData = this.filterService.allLocationData[resp.state];
            if(stateData?.length) {
              const flrData = stateData.filter((f: any) => f[this.groupConfigKey.toString()] == fnd[this.groupConfigKey.toString()] && f.zip_code == resp.postcode);
              this.mergeObjectsInUnique(flrData);
            }
          }
          this.showToggle = true;
          this.toggleSelection = 'location';
        }
      })
    );
  }

  toggleSelectionChange() {
    if(this.showToggle && this.toggleSelection == 'state') {
      this.loadLocationLevelApi(this.currentStateCode);
    }
    setTimeout(() => this.cdr.detectChanges());
  }

  sortBychange() {
    this.sortingIcon = false;
    this.sortApiChanges();
  }

  sortByIconchange() {
    this.sortingIcon = !this.sortingIcon;
    this.sortApiChanges();
  }

  sortApiChanges() {
    if(this.toggleSelection=='location') {
      let obj = {
        "api_key": 100124,
        "report_typ": "L",
        "hcp_state" : this.currentStateCode,
        "sort_col": this.sortByvalue,
        "sort_order": this.sortingIcon ? 'DESC' :'ASC'
      }

      if(this.sortByvalue=='prescriber_count') {
        obj.sort_col = "prescriber_nm"
      }
      let endPoint = this.item.config?.["list_of_api_endpoint"];
      if (this.filterService.isEmptyObject(this.filterService.baseQuery) == false) { 
        this.reqSubcription.push(this.filterService.executePatientQuery(obj, endPoint).subscribe((res: any) => {
          const allData = res ? res : [];
          this.filterService.allLocationData[this.currentStateCode] = allData;
          this.locationLevelDataAgg(this.currentStateCode, this.filterService.allLocationData[this.currentStateCode]);
          this.showToggle = true;
        }, (err: any) => {
          this.showToggle = true;
        }))
      }
    } else {
      let payload:any = {
        sort_col: this.sortByvalue,
        sort_order: this.sortingIcon ? 'DESC' :'ASC'
      }
      this.loadApiData(payload);
    }
  }

  loadApiData(payload:any) {
    let obj:any = {
      api_key: 100124,
      report_typ: "D"
    }

    Object.assign(obj, payload)
    let endPoint = this.item.config?.["list_of_api_endpoint"];
    if (this.filterService.isEmptyObject(this.filterService.baseQuery) == false) { 
      this.reqSubcription.push(this.filterService.executePatientQuery(obj, endPoint).subscribe((res: any) => {
        this.allData = res ? res : [];
        this.mergeObjectsInUnique(this.allData);
      }, (err: any) => {

      }))
    }
  }

  loadPatientStatusJourneyApi(expention:any, data:any) {
    if(!expention) {
      this.statusArrayforPrescriber = [];
      if(!this.filterService.patientStatusJouneryArray[data.name]) {
        const obj = {
          api_key: 100201,
          report_typ: "P",
          prescriber_nm : data.name
        }
        this.patientStatusJourneyFlg = true;
        let endPoint = this.item.config?.["list_of_api_endpoint"];
        if(this.filterService.isEmptyObject(this.filterService.baseQuery) == false) {
          this.reqSubcription.push(this.filterService.executePatientQuery(obj, endPoint).subscribe((res: any) => {
            const rowdata = res ? res : [];
            this.patientStatusJourney(rowdata, data.name);
          }, (error: any) => {
            this.patientStatusJourney([], data.name);
            }
          ))
        }
      } else {
        this.statusArrayforPrescriber = this.filterService.patientStatusJouneryArray[data.name]
      }
    }
  }

  patientStatusJourney(data:any, name:any) {
    
    if(data.length == 0) {
      this.filterService.patientStatusJouneryArray[name] = [];
      this.statusArrayforPrescriber = this.filterService.patientStatusJouneryArray[name];
      this.patientStatusJourneyFlg = false;

      return;
    }

    const groupedByPatient = _.groupBy(data, 'patient_dim_key');
    let statusJourney = [];
    
    for(let key in groupedByPatient) {
      let statusJourneys: any = {
        id: key,
        name: groupedByPatient[key][0]['referral_source'],
        color: groupedByPatient[key][0]['referral_source'] == 'SP' ? '#FFCD4A' : '#844AFF',
        status: groupedByPatient[key],
        navObj: this.configToShowStatusJourney,
      }
      statusJourney.push(statusJourneys)
    }

    this.filterService.patientStatusJouneryArray[name] = [...statusJourney];
    this.statusArrayforPrescriber = this.filterService.patientStatusJouneryArray[name];
    this.patientStatusJourneyFlg = false;
  }

  ngOnInit(): void {
    this.route.params.subscribe((p: any) => {
      this.moduleName = p['module'] || '';
      this.cardName = p['cardName'] || '';

      this.route.queryParams.subscribe((params: any) => {
        this.decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = this.decryptedParams["cl_key"];
        this.moduleKey = this.decryptedParams["md_key"];
        this.dashboardKey = this.decryptedParams["ds_key"];
      });
    });
  }

  loadLocationLevelApi(state:any){
    if(!this.filterService.allLocationData[state]) {
      const obj = {"api_key": 100124,"report_typ": "L","hcp_state" : state}
      let endPoint = this.item.config?.["list_of_api_endpoint"];
      if (this.filterService.isEmptyObject(this.filterService.baseQuery) == false) { 
        this.reqSubcription.push(this.filterService.executePatientQuery(obj, endPoint).subscribe((res: any) => {
          const allData = res ? res : [];
          this.filterService.allLocationData[state] = allData;
          this.locationLevelDataAgg(state, this.filterService.allLocationData[state]);
          this.showToggle = true;
        }, (err: any) => {
          this.showToggle = true;
        }))
      }
    } else {
      this.locationLevelDataAgg(state, this.filterService.allLocationData[state]);
      this.showToggle = true;
    }
  }

  locationLevelDataAgg(state:any, allData:any) {
    // debugger
    let fnd = this.allData.find((o: any) => o.state_cd == state);
    if (fnd) {
      this.groupData = this.backUpGroupedData.filter((f: any) => f.name == fnd[this.groupConfigKey.toString()]);
      this.groupData[0]['allLocData'] = [...allData];
      this.groupData[0]['location_values'] = [];
      // Location Display Values;
      const groupedLocObjects = this.groupObjectsBy(allData, this.groupLocConfigKey);
      const groupedLocArray = Object.entries(groupedLocObjects).map(([key, value]) => ({ key: key, values: value }));

      // Location and Status Configuration
      for (let index = 0; index < groupedLocArray.length; index++) {
        const locElement: any = groupedLocArray[index];
        let modifyLocObj: any = {};

        modifyLocObj['name'] = locElement.key;
        modifyLocObj['value'] = [];
        modifyLocObj['statusJourney'] = [];

        this.configToShowLocationValues.map((m: any) => {
          if (m.type.toLowerCase() == 'number') {
            modifyLocObj['value'].push({
              name: m.disp_name,
              value: this.reduceTheNumber(locElement.values, m.value_name),
              obj: m
            })
          } else {
            modifyLocObj['value'].push({
              name: m.disp_name,
              value: this.reduceTheString(locElement.values, m.value_name),
              obj: m
            })
          }

          // if(m.disp_name.toLowerCase()!='prescriber') {
          //   if (m.type.toLowerCase() == 'number') {
          //     modifyLocObj['value'].push({
          //       name: m.disp_name,
          //       value: this.reduceTheNumber(locElement.values, m.value_name),
          //       obj: m
          //     })
          //   } else {
          //     modifyLocObj['value'].push({
          //       name: m.disp_name,
          //       value: this.reduceTheString(locElement.values, m.value_name),
          //       obj: m
          //     })
          //   }
          // } else {
          //   modifyLocObj['value'].push({
          //     name: m.disp_name,
          //     value: this.reduceTheString(locElement.values, m.value_name),
          //     obj: m
          //   })
          // }
        })

        // debugger
        
        const groupedByPatient = _.groupBy(this.statusArray, 'du_patient_id');

        locElement.values.forEach((o: any) => {
          let statusJourneys: any = {
            id: o.patient_id,
            name: o.referral_source,
            color: o.referral_source == 'SP' ? '#FFCD4A' : '#844AFF',
            status: groupedByPatient[o.patient_id],
            navObj: this.configToShowStatusJourney,
          }
          modifyLocObj['statusJourney'].push(statusJourneys);
        });


        this.groupData[0]['location_values'].push(modifyLocObj);
      }
      

    }
  }

  // Account Level
  routerGroupHandler(item: any) {
    this.setNavigationData(item.navObj);
    this.routerHandlerService.storingPayloadAndFilterForGrid(item.navObj, item.allData[0], this.cardName);
    let spl = item.name.split(',');
    let query: any = Object.assign({}, this.decryptedParams, {'tab_id': 0}, {'acc_nm': spl.pop()});
    let queryMaped = this.navigationService.movePropertyToFirst(query, 'tab_id');
    this.navigationService.routerNavigate(`dashboard/${this.moduleName}/${'pwt'}/${spl.pop()}`, queryMaped);
  }

  // State Level 
  routerHandler(item: any, value: any) {
    this.setNavigationData(value.obj);
    this.routerHandlerService.storingPayloadAndFilterForGrid(value.obj, item.allData[0], this.cardName);
    let query: any = Object.assign({}, this.decryptedParams, {'tab_id': 0});
    let queryMaped = this.navigationService.movePropertyToFirst(query, 'tab_id');
    this.navigationService.routerNavigate(`dashboard/${this.moduleName}/${'pwt'}/${value.name}`, queryMaped);
  }
  // Location Level
  routerHandlerLocation(item: any, value: any, idx:any) {
    // debugger
    let data = item.allLocData.find((f:any)=> f[this.groupLocConfigKey[0]] == item.location_values[idx].name);
    if(data) {
      this.setNavigationData(value.obj);
      this.routerHandlerService.storingPayloadAndFilterForGrid(value.obj, data, this.cardName);
      let query: any = Object.assign({}, this.decryptedParams, {'tab_id': 0});
      let prName = 'prescriber_nm';
      query['prescriber'] = data[prName];
      let queryMaped = this.navigationService.movePropertyToFirst(query, 'tab_id');

      this.navigationService.routerNavigate(`dashboard/${this.moduleName}/${'pwt'}/${value.name}`, queryMaped);
    }
  }

  trackByItem(index: number): any {
    return index;
  }
  
  trackByItemLocation(index: number): any {
    return index;
  }
  
  // Prescriber Card Level
  routerHandlerPrescriberCard(item: any, value: any) {
    // debugger
    this.setNavigationData(value.obj);
    let fndData = item.allLocData.find((o: any) => o[value.obj.value_name] == value.value.toString());
    
    if (fndData) {
      
      this.routerHandlerService.storingPayloadAndFilterForGrid(value.obj, fndData, this.cardName);
      let query: any = Object.assign({}, this.decryptedParams, { cardId: fndData['prescriber_id']}, {'tab_id': 0});
      
      // Prescriber Name Header
      if (value.obj.pageName?.toString().replace(/\s+/g, '').toLowerCase() == 'prescribercard') {
        // Prescriber Name
        let prName = 'prescriber_nm'
        if (fndData[prName]) {
          if (fndData[prName].includes(',')) {
            sessionStorage.setItem("navbar_prName", fndData[prName].replaceAll(',', ''));
          } else {
            sessionStorage.setItem("navbar_prName", fndData[prName]);
          }
        }
        query['prescriber'] = fndData[prName];
      }

      let queryMaped = this.navigationService.movePropertyToFirst(query, 'tab_id');
      this.navigationService.routerNavigate(`dashboard/${this.moduleName}/${value.obj.pageName}`, queryMaped);
    }
  }

  // Patient Card
  routerHandlerPatientCard(item: any, status: any) {
    // Set Navigation
    let config = status.navObj;
    let nav = {
      dbJSON: config?.dbJSON,
      s3JSON: config?.s3JSON,
      pageName: config?.pageName,
      isDashboardLevel: config?.isDashboardLevel,
      notes : {
        isNotes: config?.isNotes || false, 
        dashboardName: config?.notesDisplayName,
        dashboardKey: config?.notesDashboardKey,
        filterKey: config?.uniqueDetailKey || 'patient_key'
      }
    }
    this.routerHandlerService.navDetailInfo(nav);

    // let fndData = item.allData.find((o: any) => o[status.navObj.value_name] == status.id);
    
    this.filterService.baseQuery['patient_id'] = status.id;
    this.newFilterService.setPatientStatusBaseQuery(this.filterService.baseQuery);

    // if (fndData) {
      this.routerHandlerService.storingPayloadAndFilterForGrid(status.navObj, {}, this.cardName);

      let query: any = Object.assign({}, this.decryptedParams, { cardId: status.id }, {'tab_id': 0});
      let queryMaped = this.navigationService.movePropertyToFirst(query, 'tab_id');
      this.navigationService.routerNavigate(`dashboard/${this.moduleName}/${status.navObj.pageName}`, queryMaped);
    // }
  }

  // Set Navigations
  setNavigationData(config: any) {
    let nav = {
      dbJSON: config?.dbJSON,
      s3JSON: config?.s3JSON,
      pageName: config?.pageName,
      isDashboardLevel: config?.isDashboardLevel,
      notes : {
        isNotes: config?.isNotes || false, 
        dashboardName: config?.notesDisplayName,
        dashboardKey: config?.notesDashboardKey,
        filterKey: config?.uniqueDetailKey || ''
      }
    }
    this.routerHandlerService.navDetailInfo(nav);
  }

  ngOnChanges(changes: SimpleChanges): void {
    let cfg = this.item.config;
    console.log("cfg", cfg);

    // Group Configuration
    let grp = cfg['main_configuration']?.['controls'];

    this.groupConfigKey = [grp[0].value_name];
    this.groupConfigObj = grp[0];

    // Child Group Configuration
    this.groupLocConfigKey = [cfg['locationGroupConfig']]

    this.configToShowStateValues = cfg['nav_view_configuration']?.['controls'];
    this.configToShowLocationValues = cfg['nav_location_configuration']?.['controls'];
    this.configToShowStatusJourney = cfg['nav_status_journey_configuration']?.['controls']?.[0] || {};

    if (changes['allData']?.currentValue != changes['allData']?.previousValue) {
      this.allData = changes['allData'].currentValue || [];
      this.mergeObjectsInUnique(this.allData);
    }
  }

  reduceTheNumber(data: any, name: any) {
    return data.reduce((acc: any, val: any) => acc += Number(val[name]), 0);
  }

  reduceTheString(data: any, name: any) {
    // Extract unique names from the array of objects
    const uniqueNamesSet = new Set(data.map((obj: any) => obj[name]));
    // Convert Set to Array
    return Array.from(uniqueNamesSet);
  }

  groupObjectsBy(array: any[], keys: string[]): { [key: string]: any[] } {
    return array.reduce((result, currentValue) => {
      const groupKey = keys.map(key => currentValue[key]).join('-');
      (result[groupKey] = result[groupKey] || []).push(currentValue);
      return result;
    }, {});
  }

  // Data Mapping
  mergeObjectsInUnique(data: any[]) {
    this.groupData = [];
    // debugger
    const groupedStateObjects = this.groupObjectsBy(data, this.groupConfigKey);
    const groupedStateArray = Object.entries(groupedStateObjects).map(([key, value]) => ({ key: key, values: value }));

    if (groupedStateArray?.length) {

      // State Level Configuration
      for (let index = 0; index < groupedStateArray.length; index++) {
        const element: any = groupedStateArray[index];
        let modifyObj: any = {};

        modifyObj['name'] = element.key;
        modifyObj['allData'] = element.values;
        modifyObj['allLocData'] = element.values;
        modifyObj['state_values'] = [];
        modifyObj['location_values'] = [];
        modifyObj['navObj'] = this.groupConfigObj;
        modifyObj['sortOrder'] = {};

        // State Display Value
        this.configToShowStateValues.map((m: any) => {
          let presName = this.reduceTheString(element.values, m.value_name)
          if (m.type.toLowerCase() == 'number') {
            modifyObj['state_values'].push({
              name: m.disp_name,
              value: this.reduceTheNumber(element.values, m.value_name),
              obj: m
            })
            modifyObj['sortOrder'][m.value_name] = this.reduceTheNumber(element.values, m.value_name)
          } else {
            modifyObj['state_values'].push({
              name: m.disp_name,
              value: presName.length,
              obj: m
            })
            modifyObj['sortOrder'][m.value_name] = presName.length
          }
        });

        // Location Display Values;
        const groupedLocObjects = this.groupObjectsBy(element.values, this.groupLocConfigKey);
        const groupedLocArray = Object.entries(groupedLocObjects).map(([key, value]) => ({ key: key, values: value }));

        // Location and Status Configuration
        for (let index = 0; index < groupedLocArray.length; index++) {
          const locElement: any = groupedLocArray[index];
          let modifyLocObj: any = {};

          modifyLocObj['name'] = locElement.key;
          modifyLocObj['value'] = [];
          modifyLocObj['statusJourney'] = [];

          this.configToShowLocationValues.map((m: any) => {
            if (m.type.toLowerCase() == 'number') {
              modifyLocObj['value'].push({
                name: m.disp_name,
                value: this.reduceTheNumber(locElement.values, m.value_name),
                obj: m
              })
            } else {
              modifyLocObj['value'].push({
                name: m.disp_name,
                value: this.reduceTheString(locElement.values, m.value_name),
                obj: m
              })
            }
          })

          const groupedByPatient = _.groupBy(this.statusArray, 'du_patient_id');

          locElement.values.forEach((o: any) => {
            let statusJourneys: any = {
              id: o.patient_id,
              name: o.referral_source,
              color: o.referral_source == 'SP' ? '#FFCD4A' : '#844AFF',
              status: groupedByPatient[o.patient_id],
              navObj: this.configToShowStatusJourney,
            }
            modifyLocObj['statusJourney'].push(statusJourneys);
          });


          modifyObj['location_values'].push(modifyLocObj);
        }

        this.groupData.push(modifyObj);
      };
    }

    function sortByKey(array: any[], key: string, order: "asc" | "desc") {
      return array.sort((a, b) => {
          const valueA = a.sortOrder[key] ?? 0; // Default to 0 if key is missing
          const valueB = b.sortOrder[key] ?? 0;
  
          return order === "asc" ? valueA - valueB : valueB - valueA;
      });
    }
    
    if(this.sortByvalue != 'account_name') {
      this.groupData = sortByKey(this.groupData, this.sortByvalue, this.sortingIcon ? 'desc' :'asc');
    }

    if (this.backUpGroupedData.length == 0) this.backUpGroupedData = [...this.groupData];

  }

  // Kill Component
  ngOnDestroy() {
    this.reqSubcription.forEach((res: any) => res.unsubscribe());
  }
}
